// utils/helperFunctions/getSimpleCheckAllowedEmails.js
import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../../../../../../backend/firebaseconfig";

export const getSimpleCheckAllowedEmails = async () => {
  try {
    const ref = doc(db, "Compliance", "Check²");
    const snap = await getDoc(ref);

    if (!snap.exists()) return [];

    const data = snap.data();

    //  change this field name to whatever you're storing
    // e.g. simpleCheckUsers, simpleUsers, etc.
    const users = Array.isArray(data?.simpleCheckUsers)
      ? data.simpleCheckUsers
      : [];

    return users;
  } catch (err) {
    console.error("Failed to fetch simple check allowed emails", err);
    return [];
  }
};
